module.exports = __webpack_public_path__ + "static/logo-45dc538021e0321106319e1d5c997bb6.svg";